import { FC, useEffect, useState } from 'react';
import { ExtendedGridColDef } from '@/types/ExtendedGridColDef';
import { Grid, Button, Box } from '@mui/material';
import { SCUIContent } from '../../atomic/organisms';
import { SCUICustomDataGrid, SCUIGeneralDrawer } from '../../atomic/molecules';
import { OmnichannelQuery } from '../../services/query';
import { useTranslation } from 'react-i18next';
import MenuIcon from '@mui/icons-material/Menu';
import { SCUIStoreListDrawerContent } from '../../atomic/molecules/SCUIStoreListDrawerContent/SCUIStoreListDrawerContent';
import { STL } from './storeList.classes';

export const StoreList: FC<any> = () => {
    const { t } = useTranslation();
    const [state, setState] = useState({
        right: false,
    });
    const [storelist, setStoreList] = useState([]);
    const [store, setStore] = useState<any>();
    const [storeId, setStoreId] = useState<any>();
    const [refresh, setRefresh] = useState(false);

    const onDrawerOpen = () => setState({ ...state, right: true });
    const onDrawerClose = () => setState({ ...state, right: false });

    const refreshDesignCollective = () => {
        setRefresh((prevLoading) => !prevLoading);
    };

    useEffect(() => {
        getStoreList();
    }, [refresh]);

    const columns: ExtendedGridColDef[] = [
        {
            field: 'storeCode',
            headerName: t('omnichannel.storeId'),
            flex: 1,
            renderCell: (params: any) => (
                <span className={STL.cellStoreCode} data-store-code={params.row.storeCode}>
                    {params.row.storeCode}
                </span>
            ),
        },
        {
            field: 'storeName',
            headerName: t('omnichannel.storeName'),
            flex: 1,
            renderCell: (params: any) => (
                <span className={STL.cellStoreName} data-store-name={params.row.storeName}>
                    {params.row.storeName}
                </span>
            ),
        },
        {
            field: 'address',
            headerName: t('omnichannel.storeAddress'),
            flex: 1,
            hide: true,
        },
        {
            field: 'email',
            headerName: t('omnichannel.email'),
            flex: 1,
            renderCell: (params: any) => (
                <span className={STL.cellEmail} data-email={params.row.email}>
                    {params.row.email}
                </span>
            ),
        },
        {
            field: 'adress',
            headerName: t('omnichannel.storeAddress'),
            flex: 1,
            renderCell: (params: any) => (
                <span className={STL.cellAddress} data-address={params.row.adress}>
                    {params.row.adress}
                </span>
            ),
        },
        {
            field: 'phoneNumber',
            headerName: t('omnichannel.phone'),
            flex: 1,
            hide: true,
        },
        {
            field: 'cityId',
            headerName: t('omnichannel.city'),
            flex: 1,
            renderCell: (params: any) => (
                <span className={STL.cellCity} data-city={params.row.cityId}>
                    {params.row.cityId}
                </span>
            ),
        },
        {
            field: 'districtId',
            headerName: t('omnichannel.districtId'),
            flex: 1,
            renderCell: (params: any) => (
                <span className={STL.cellDistrict} data-district={params.row.districtId}>
                    {params.row.districtId}
                </span>
            ),
        },
        {
            field: 'düzenle',
            headerName: t('general.edit'),
            flex: 1,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => {
                const onclick = () => {
                    setStore(params.row);
                    setStoreId(params.row.id);

                    onDrawerOpen();
                };
                return (
                    <div className={STL.cellEdit}>
                        <Button onClick={onclick} className={STL.btnEdit} data-store-id={params.row.id}>
                            <MenuIcon />
                        </Button>
                    </div>
                );
            },
        },
    ];
    const getStoreList = () => {
        OmnichannelQuery.StoreList()
            .then((res: any) => {
                if (res) {
                    console.info(res);
                    let parseData = res.data.map((item: any) => {
                        return {
                            id: item.storeId || '-',
                            storeCode: item.storeCode || '',
                            storeName: item.storeName || '-',
                            email: item.notificationEmailAddress || '-',
                            adress: item.address || '-',
                            phone: item.storePhone || '-',
                            cityId: item.storeCityName || '-',
                            districtId: item.storeCountyName || '-',
                            storeStatus: item.storeStatus || '-',
                        };
                    });
                    setStoreList(parseData);
                }
            })
            .catch((error: any) => {
                console.log('Hata :>> ', error);
            });
    };

    return (
        <SCUIContent className={STL.page}>
            <Grid
                className={STL.header}
                size={{
                    lg: 10,
                    md: 12,
                    xs: 12,
                }}
            >
                <h1 className={`headtxt ${STL.title}`}>{t('dashboard.storeList')}</h1>
            </Grid>
            <Box className={STL.root}>
                <SCUIGeneralDrawer
                    open={state['right']}
                    anchor="right"
                    width={'80rem'}
                    onClose={(_: any, reason: any) => {
                        if (reason === 'backdropClick') {
                            setState({ ...state, right: false });
                        }
                    }}
                >
                    <Box className={`${STL.drawer} ${STL.drawerContent}`}>
                        <SCUIStoreListDrawerContent
                            id={storeId}
                            detail={store}
                            onClose={onDrawerClose}
                            onUpdate={refreshDesignCollective}
                        />
                    </Box>
                </SCUIGeneralDrawer>
                <Box className={STL.grid}>
                    <SCUICustomDataGrid rows={storelist} columns={columns} />
                </Box>
            </Box>
        </SCUIContent>
    );
};
